import { useEffect } from 'react';
import type { PublicAgent } from '@magic/schemas/agents';
import type { UTM } from '@magic/schemas/leads';
import { useLocalStorage } from '@magic/ui/hooks/use-local-storage';
import { useSearchParams } from 'react-router-dom';

export interface UseUTMParams {
  agent: PublicAgent;
}

export const useUTM = ({ agent }: UseUTMParams) => {
  const [params] = useSearchParams();
  const [utm, setUtm] = useLocalStorage<UTM>(`utm_${agent.id}`, undefined!);

  useEffect(() => {
    const source = params.get('utm_source');
    if (source) {
      const medium = params.get('utm_medium');
      const campaign = params.get('utm_campaign');
      const content = params.get('utm_content');
      const term = params.get('utm_term');
      setUtm({ source, medium, campaign, content, term });
    }
  }, [params, setUtm]);

  return utm;
};
